import gql from 'graphql-tag'

export const fetchSuggestedCartGroupedQuery = gql`
query ($ship_tos: [String], $search: String) {
  getSuggestedCarts(ship_tos: $ship_tos, search: $search) {
      items_with_classification {
        classification_title
        items {
          sku
          image
          name
          number_of_items_on_pallet
          number_of_items_on_layer
          total_units
          units
          number_of_layers
          number_of_pallets
          price_per_piece
          product_last
          product_new
          product_sale
          product_recommended
          promo_price_leaflet{
            promo_price_is_inside_delivery
        }
          product_special
          is_in_flexible_package
          fixed_package {
          is_in_fixed_package
           fixed_sku {
            sku
          }
          }
          your_price_wo_vat
          your_price_w_vat
          redemption_fee
          multi_deposit_z099
          tags {
          value
          label
          color
        }
        }
      }
      has_packages
      items {
        summary_total_amount_wo_vat
        summary_total_amount_to_pay_for_goods
        summary_total_empty_deposit
        suggested_cart_total
        shipping_address {
          payer_name
          outlet_name
          street
          city
          country
          province
          postalcode
          sap_id
        }
        products {
          sku
          image
          name
          number_of_items_on_pallet
          number_of_items_on_layer
          total_units
          units
          promo_price_leaflet{
            promo_price_is_inside_delivery
        }
          product_last
          product_new
          product_sale
          product_recommended
          product_special
          number_of_layers
          number_of_pallets
          price_per_piece
          your_price_wo_vat
          your_price_w_vat
          redemption_fee
          fixed_package {
            is_in_fixed_package
             fixed_sku {
            sku
          }
          }
          multi_deposit_z099
          is_in_flexible_package
          tags {
          value
          label
          color
        }
        }
      }
    }
  }
`
